class Manager {
  map = {}

  constructor() {}

  getPlayerInstance = (id) => {
    return this.map[id];
  };

  setPlayerInstance = (id, instance) => {
    this.map[id] = instance;
  };
}

const instance = new Manager();
export default instance;



// WEBPACK FOOTER //
// ./src/components/VideoV2/Manager.js